<script setup>
import { computed, ref } from 'vue'
import FeedbackCard from '../atoms/FeedbackCard.vue'
import { sendGTagEvent } from '@/helpers/gtag'
import ContinueButton from '../molecules/ContinueButton.vue'

const { title, options, propSelectedIndex, isWithFeedback, gridCols } = defineProps([
  'title',
  'text',
  'options',
  'selectedIndex',
  'isWithFeedback',
  'gridCols'
])

const selectedIndex = ref(propSelectedIndex)
const isSelected = computed(() => selectedIndex.value !== undefined)

const emit = defineEmits(['selection'])

// TODO: update send only in gender selection, check text logic
function sendSelectionEventInCase(index) {
  if (options[index]?.sendGTag)
    sendGTagEvent({ event: 'gender_collected', gender: options[index].text })
  emit('selection', index)
}
</script>

<template>
  <div class="component-container">
    <div class="title component-card title-card">
      <p class="heading-5">{{ title }}</p>
      <p class="p-md" v-if="text">{{ text }}</p>
    </div>
    <div v-if="isWithFeedback && isSelected" style="flex: 1;"></div>
    <FeedbackCard
      class="mt-24"
      v-if="isWithFeedback && isSelected && options[selectedIndex].feedback"
      :title="options[selectedIndex].feedback.title"
      :text="options[selectedIndex].feedback.text"
    />
    <div class="mt-24 select-container">
      <button
        :class="`component-card btn select-button p-md mt-8 ${selectedIndex === index ? 'selected' : ''} ${option.subtext ? 'with-subtext' : ''}`"
        :style="{ width: `${100 / gridCols - 1}%`}"
        v-for="(option, index) in options"
        :key="option"
        @click="
          () => {
            selectedIndex = index
            if (!isWithFeedback) sendSelectionEventInCase(index)
          }
        "
      >
        <div class="texts" v-if="option.icon">
          <span class="icon">{{ option.icon }}</span>
          <span>{{ option.text || option }}</span>
          <span class="p-md subtext" v-if="option.sideText">{{ option.sideText }}</span>
        </div>
        <span class="p-md subtext" v-if="option.subtext">{{ option.subtext }}</span>
      </button>
    </div>
    <ContinueButton
      v-if="isWithFeedback"
      :disabled="selectedIndex === undefined"
      @click="sendSelectionEventInCase(selectedIndex)"
    />
  </div>
</template>

<style scoped>
.select-button {
  padding-top: 20px;
  padding-bottom: 20px;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.title-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  text-align: left;
}

.icon {
  font-size: 28px;
}

.texts {
  display: flex;
  align-items: center;
  gap: 4px;
  text-align: left;
}

.select-container {
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex-wrap: wrap;
}

.btn {
  align-items: center;
  border-radius: 80px;
}

.title {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.subtext {
  margin-left: auto;
  color: var(--neutrals-400);
}

.select-button {
  text-align: left;
  width: 100%;
}

.heading-5 {
  color: var(--neutrals-900, #0A0D14);
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px; /* 128.571% */
  letter-spacing: -0.28px;
}


@media screen and (max-width: 850px) {

}
</style>
